import { isNative } from "./nativeHttp";

// The /app theme. An explicit in-app choice (the sun/moon toggles write
// "true"/"false") always wins; with no choice made, the NATIVE app follows
// the phone's own light/dark setting, and the web defaults to light as it
// always has.
export function appThemeDark() {
  try {
    const stored = localStorage.getItem("appDarkMode");
    if (stored === "true") return true;
    if (stored === "false") return false;
  } catch { /* storage blocked: fall through */ }
  if (isNative) {
    try { return window.matchMedia("(prefers-color-scheme: dark)").matches; } catch { /* no matchMedia */ }
  }
  return false;
}

// Follow live phone theme changes while the user has made no in-app choice.
// Returns a cleanup function.
export function watchDeviceTheme(onChange) {
  if (!isNative) return () => {};
  try {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => {
      try { if (localStorage.getItem("appDarkMode") != null) return; } catch { return; }
      onChange(e.matches);
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  } catch {
    return () => {};
  }
}
